import { Notes, NoteTone } from "@shared/ui";

interface AttendeeNotesProps {
  notes?: string;
  tone?: NoteTone;
  loading?: boolean;
  toneOptions: Array<{
    value: NoteTone;
    label: string;
    description: string;
  }>;
  onDataChange?: (updates: Record<string, string>) => void;
}

function AttendeeNotes({
  notes = "",
  tone = "default",
  loading = false,
  toneOptions,
  onDataChange,
}: AttendeeNotesProps) {
  return (
    <Notes
      notes={notes}
      tone={tone}
      loading={loading}
      toneOptions={toneOptions}
      onDataChange={onDataChange}
      noteField="privateNote"
      toneField="privateNoteTone"
      asCard={false}
    />
  );
}

export default AttendeeNotes;
